module.exports = __webpack_public_path__ + "static/img/news7-cover.379464d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news7-cover.jpg
// module id = 41a9
// module chunks = 0